











import Vue from "vue";
import Star from "@/components/Atoms/Rates/Star/index.vue";
import { FillType } from "@/components/Atoms/Rates/Star/types";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Star
  },
  props: {
    size: {
      type: Number,
      default: 14
    },
    rate: {
      type: Number,
      default: 0,
      validator: function(value) {
        return 0 <= value && value <= 5; //Rateが取りうる値の下限と上限
      }
    }
  },
  methods: {
    getFillType(index) {
      const rate = Number(this.rate.toFixed(1));
      if (rate >= index) {
        return FillType.Filled;
      } else if (rate >= index - 0.5) {
        return FillType.Half;
      } else {
        return FillType.Empty;
      }
    }
  }
});
